module.exports = __webpack_public_path__ + "static/media/reward-e.35fae371.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sprites/reward-e.png
// module id = 1871
// module chunks = 0